import { render } from "./SaleTonajChart.vue?vue&type=template&id=51bd7106"
import script from "./SaleTonajChart.vue?vue&type=script&lang=js"
export * from "./SaleTonajChart.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\tabarok_management\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__